export const TROLL_GAME_ID = 2067532;
export const SAVE_THE_TREES_ID = 2074194;